import { render, staticRenderFns } from "./OnboardingCalendarSyncPage.vue?vue&type=template&id=422b67fb"
import script from "./OnboardingCalendarSyncPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingCalendarSyncPage.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingCalendarSyncPage.vue?vue&type=style&index=0&id=422b67fb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports